module.exports = __webpack_public_path__ + "img/video-player/nervous@3x-122c8c7c4c47290d7987c75a27328eaa.png";